import { VueConstructor } from 'vue';

// Layout
import Loader from '@/components/Loader.vue';

// Interrogation
import Interrogation from '@/components/Interrogation.vue';

// Modals
import Modal from '@/components/modal/Modal.vue';
import ModalFooterActions from '@/components/modal/components/FooterActions.vue';
import ConfirmModal from '@/components/modal/Confirm.vue';
import AlertModal from '@/components/modal/Alert.vue';
import InfoModal from '@/components/modal/Info.vue';

// Input
import Input from '@/components/input/Input.vue';
import Button from '@/components/input/Button.vue';

// Actions (icons)
import ActionEdit from '@/components/actions/Edit.vue';
import ActionRemove from '@/components/actions/Remove.vue';
import ActionToggle from '@/components/actions/Toggle.vue';

// Price
import Price from '@/components/Price.vue';

// Tiles
import Tile from '@/components/tile/Tile.vue';
import TileWrapper from '@/components/tile/TileWrapper.vue';

// Label
import Label from '@/components/Label.vue';

// Steps
import StepHeading from '@/components/step/StepHeading.vue';

// Counter
import Counter from '@/components/Counter.vue';

// Summary
import Summary from '@/components/summary/Summary.vue';
import SummaryItem from '@/components/summary/SummaryItem.vue';

// Selected
import Selected from '@/components/Selected.vue';

/**
 *  Vue plugin for the global components: components that
 *  can be used troughout the whole tool without adding
 *  them to the components of the component.
 */
class CCOSGlobalComponentsPlugin {

    /**
     *
     *  Used to install the global components.
     *
     *  @param Vue The Vue constructor to register the components for
     *
     */
    public install(Vue: VueConstructor): void {

        // Layout
        Vue.component('Loader', Loader);

        // Interrogation
        Vue.component('Interrogation', Interrogation);

        // Modal
        Vue.component('Modal', Modal);
        Vue.component('ModalFooterActions', ModalFooterActions);
        Vue.component('ConfirmModal', ConfirmModal);
        Vue.component('AlertModal', AlertModal);
        Vue.component('InfoModal', InfoModal);

        // Input
        Vue.component('Input', Input);
        Vue.component('Button', Button);

        // Actions (icons)
        Vue.component('ActionEdit', ActionEdit);
        Vue.component('ActionRemove', ActionRemove);
        Vue.component('ActionToggle', ActionToggle);

        // Price
        Vue.component('Price', Price);

        // Tile
        Vue.component('Tile', Tile);
        Vue.component('TileWrapper', TileWrapper);

        // Label
        Vue.component('Label', Label);

        // Step
        Vue.component('StepHeading', StepHeading);

        // Counter
        Vue.component('Counter', Counter);

        // Summary
        Vue.component('Summary', Summary);
        Vue.component('SummaryItem', SummaryItem);

        // Selected
        Vue.component('Selected', Selected);

    }

}

export default new CCOSGlobalComponentsPlugin();
